/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { CardWithUserAccountResourceLightUser } from './card-with-user-account-resource-light-user';
// May contain unused imports in some cases
// @ts-ignore
import { CardWithUserAccountResourceLightUserAccountGroup } from './card-with-user-account-resource-light-user-account-group';

/**
 * 
 * @export
 * @interface CardWithUserAccountResourceLight
 */
export interface CardWithUserAccountResourceLight {
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isCreaditCard'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isOnDemand'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {CardWithUserAccountResourceLightUser}
     * @memberof CardWithUserAccountResourceLight
     */
    'user'?: CardWithUserAccountResourceLightUser;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'userAccountId': string;
    /**
     * 
     * @type {CardWithUserAccountResourceLightUserAccountGroup}
     * @memberof CardWithUserAccountResourceLight
     */
    'userAccountGroup'?: CardWithUserAccountResourceLightUserAccountGroup;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'resourceScope': CardWithUserAccountResourceLightResourceScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'role': CardWithUserAccountResourceLightRoleEnum;
}

export const CardWithUserAccountResourceLightResourceScopeEnum = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type CardWithUserAccountResourceLightResourceScopeEnum = typeof CardWithUserAccountResourceLightResourceScopeEnum[keyof typeof CardWithUserAccountResourceLightResourceScopeEnum];
export const CardWithUserAccountResourceLightRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type CardWithUserAccountResourceLightRoleEnum = typeof CardWithUserAccountResourceLightRoleEnum[keyof typeof CardWithUserAccountResourceLightRoleEnum];


